import { ApiSchemaMenuBuilder } from "../../models/apiSchema/login";
import { StorageLocalBase } from "./StorageBase";

class StorageStorageUserDataImpl extends StorageLocalBase {
  StorageNamespace = "userData";

  private readonly KeyLeftNavMenu: string = "menu";

  get Menu(): ApiSchemaMenuBuilder | undefined {
    return this.getObject(this.KeyLeftNavMenu);
  }

  set Menu(token: ApiSchemaMenuBuilder | undefined) {
    this.setObject(this.KeyLeftNavMenu, token);
  }

  Clear(): void {
    [this.KeyLeftNavMenu].forEach((key) => {
      this.delete(key);
    });
  }
}

export const StorageUserData = new StorageStorageUserDataImpl();
